import type { QueryClient } from '@tanstack/react-query'

import { queryCompanyGet } from '@api/company/company.queries'
import { queryPolicyGet } from '@api/policy/policy.queries'

export const policySheetPreload = async (
  policyUuid: string,
  queryClient: QueryClient,
) =>
  queryClient
    .ensureQueryData(queryPolicyGet(policyUuid))
    .then((policy) =>
      queryClient.ensureQueryData(queryCompanyGet(policy.companyUuid)),
    )
